/* eslint-disable react-hooks/exhaustive-deps */
'use client';
import { useEffect } from 'react';
import GameContextProvider from './context/Game/GameContextProvider';
import createChangeCurrencyNotification from './createChangeCurrencyNotification';
import GameView from './GameView';
import useRewardsNotificationStore from './hooks/useNotificationStore';

type Props = {
  isShowNotification: boolean;
  isRequiredToSwitch: boolean;
  rewardCurrencyIcon: Unit;
  walletCurrency: Unit;
  body: string;
  title: string;
  isGameCurrencyChangeEnabled: boolean;
  translations: Record<string, string>;
  rewardId: string;
};
const Game: FC<{ rewardsNotification: Props }> = ({ rewardsNotification }) => {
  const { setNotifications } = useRewardsNotificationStore();

  useEffect(() => {
    if (rewardsNotification.isShowNotification) {
      createChangeCurrencyNotification(
        rewardsNotification.body,
        rewardsNotification.title,
        rewardsNotification.isRequiredToSwitch,
        rewardsNotification.rewardCurrencyIcon,
        rewardsNotification.rewardId,
      );
      setNotifications('freeBetReward');
    }
  }, [rewardsNotification]);

  return (
    <GameContextProvider>
      <GameView freebetNotification={rewardsNotification} />
    </GameContextProvider>
  );
};

export default Game;
